
import scrollbar from '@/mixins/scrollbar';
import { debounce, throttle } from 'throttle-debounce';

export default {
  name: 'autocomplete',
  mixins: [scrollbar],
  data () {
    return {
      input: '',
      suggestions: [],
      loading: false,
      visible: false,
      privateWidth: 0,
      tipVisible: false,
      hoverIndex: 0, // hover 显示的index
      isInputingText: '', // 输入法 输入中的内容
      keyCountTime: 0, // 键盘输入间隔
      isSanCodeGan: false, // 是否是扫码枪
    };
  },
  props: {
    isWarning: {
      type: Boolean,
      default: false,
    },
    customTrem: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: 'query',
    },
    tipContent: {
      type: String,
      default: '该药品未在药品信息管理中登记',
    },
    tipBtnTxt: {
      type: String,
      default: '新增',
    },
    // input 输入值
    value: {
      type: String,
      default: '',
    },
    // 是否有添加按钮
    additional: {
      type: Boolean,
      default: false,
    },
    // 是否是商城一键入库的药品
    isShopDrugs: {
      type: Boolean,
      default: false,
    },
    // 是否有新增按钮
    addBtn: {
      type: Boolean,
      default: false,
    },
    // 搜索结果的回调函数
    fetchSuggestions: Function,
    delay: {
      type: Number,
      default: 300,
    },
    // 下拉宽度
    width: {
      type: String,
      default: '0',
    },
    // 按钮内容
    btnText: {
      type: String,
      default: '自定义新增药品',
    },
    // 焦点内容字段
    pointKey: {
      type: String,
      default: 'name',
    },
    // 显示搜索按钮
    showSearch: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请输入内容',
    },
    maxlength: {
      type: Number,
      default: 30,
    },
    // 后果接口返回的标准的数据
    currentValue: {
      type: String,
      default: '',
    },
    // 显示搜索按钮
    showIcon: {
      type: Boolean,
      default: true,
    },
    popperClass: {
      type: String,
      default: '',
    }
  },
  methods: {
    addNew () {
      this.visible = false;
      this.$emit('selectAdd', false);
    },
    blur () {
      this.$emit('blur', this.input);
    },
    focus () {
      console.log(55);
      this.getData(this.value)
    },
    select (item) {
      this.visible = false;
      this.$emit('selectHandle', item);
      if (this.state === 'query') {
        this.input = item[this.pointKey];
      }
    },
    inputHandle (e) {
      // this.$emit('update:currentValue', e);
      this.visible = true;
      this.$emit('update:value', e);
      this.debouncedGetData(e);
      this.isInputingText = '';
    },
    getData (value) {
      this.loading = true;
      this.fetchSuggestions(value, (suggestions) => {
        this.loading = false;
        if (Array.isArray(suggestions)) {
          this.suggestions = suggestions;
          this.fetchHandle();
        } else {
          console.error('[His Autocomplete Suggestions Error][Autocomplete]autocomplete suggestions must be an array');
        }
      });
    },
    // 请求结束事件响应
    fetchHandle () {
      if (this.isSanCodeGan) {
        // console.log('这是扫码枪');
        if (this.suggestions[this.hoverIndex]) {
          this.select(this.suggestions[this.hoverIndex]);
        }
        this.isSanCodeGan = false;
      }
    },
    searchHandle () {
      this.visible = false;
      this.$emit('searchHandle', this.input);
    },
    close () {
      this.visible = false;
    },
    // 处理事件
    handleFocus () {
      this.getData(this.value)
      if (!this.visible) {
        // this.visible = true;
      }
    },
    navigateOptions (direction) {
      if (!this.visible) {
        this.visible = true;
        return;
      }
      if (this.suggestions.lenth === 0) return;
      if (direction === 'next') {
        this.hoverIndex++;
        if (this.hoverIndex === this.suggestions.length) {
          this.hoverIndex = 0;
        }
      } else if (direction === 'prev') {
        this.hoverIndex--;
        if (this.hoverIndex < 0) {
          this.hoverIndex = this.suggestions.length - 1;
        }
      }
    },
    selectOption () {
      if (!this.visible) {
        this.visible = true;
        return;
      }
      // console.log(this.keyCountTime - new Date());
      // 判断键盘输入
      if (new Date() - this.keyCountTime > 80) {
        if (this.suggestions[this.hoverIndex]) {
          this.select(this.suggestions[this.hoverIndex]);
        }
      } else {
        this.isSanCodeGan = true;
        // 扫码枪输入
      }
    },
    keyDown () {
      this.keyCountTime = new Date();
    },
    // 在某些页面组件初始化的过程中组件是隐藏状态 可以重置这些宽度
    resizeWidth () {
      if (!this.width || this.width === '0') {
        let elInput = this.$refs.wrap.querySelector('input');
        this.privateWidth = elInput.offsetWidth;
        // this.privateWidth = this.$refs.wrap.offsetWidth - 24;
      } else {
        this.privateWidth = this.width;
      }
    },
  },
  mounted () {
    this.resizeWidth();
    this.debouncedGetData = debounce(this.delay, this.getData);
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.input = val;
      },
    },
    input: {
      handler (val) {
        // console.log(val)
      },
    },
  },
};
